<nz-spin [nzSpinning]="loading">
	<div class="agent-self-container">
		<h2>Edit Profile</h2>

		<form *ngIf="form" nz-form [formGroup]="form" (ngSubmit)="onSubmit()" nzLayout="vertical">
			<nz-card nzTitle="Account Information">
				<nz-form-item>
					<nz-form-label>Username</nz-form-label>
					<nz-form-control>
						<input nz-input formControlName="username" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label nzRequired>First Name</nz-form-label>
					<nz-form-control nzErrorTip="Please enter your first name (max 100 characters)">
						<input nz-input formControlName="firstName" placeholder="Enter first name" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label nzRequired>Last Name</nz-form-label>
					<nz-form-control nzErrorTip="Please enter your last name (max 100 characters)">
						<input nz-input formControlName="lastName" placeholder="Enter last name" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label nzRequired>Email Address</nz-form-label>
					<nz-form-control nzErrorTip="Please enter a valid email address">
						<input nz-input formControlName="emailAddress" placeholder="Enter email address" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label>Phone Number</nz-form-label>
					<nz-form-control nzErrorTip="Please enter a valid phone number">
						<input nz-input formControlName="msisdn" placeholder="Enter phone number" />
					</nz-form-control>
				</nz-form-item>
			</nz-card>

			<nz-card nzTitle="Change Password" class="password-card">
				<nz-form-item>
					<nz-form-label>New Password</nz-form-label>
					<nz-form-control nzErrorTip="Password must be at least 8 characters">
						<nz-input-group [nzSuffix]="newPasswordSuffix">
							<input [type]="showNewPassword ? 'text' : 'password'" nz-input formControlName="newPassword" placeholder="Enter new password" />
						</nz-input-group>
						<ng-template #newPasswordSuffix>
							<span nz-icon [nzType]="showNewPassword ? 'eye' : 'eye-invisible'" (click)="showNewPassword = !showNewPassword" class="password-toggle"></span>
						</ng-template>
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label>Confirm New Password</nz-form-label>
					<nz-form-control [nzValidateStatus]="form.errors?.['passwordMismatch'] ? 'error' : controls['confirmPassword']" [nzErrorTip]="confirmPasswordErrorTpl">
						<nz-input-group [nzSuffix]="confirmPasswordSuffix">
							<input [type]="showConfirmPassword ? 'text' : 'password'" nz-input formControlName="confirmPassword" placeholder="Confirm new password" />
						</nz-input-group>
						<ng-template #confirmPasswordSuffix>
							<span nz-icon [nzType]="showConfirmPassword ? 'eye' : 'eye-invisible'" (click)="showConfirmPassword = !showConfirmPassword" class="password-toggle"></span>
						</ng-template>
						<ng-template #confirmPasswordErrorTpl>
							<ng-container *ngIf="form.errors?.['passwordMismatch']">Passwords do not match</ng-container>
						</ng-template>
					</nz-form-control>
				</nz-form-item>
			</nz-card>

			<div class="form-actions">
				<button nz-button nzType="primary" [nzLoading]="saving" type="submit" [disabled]="form.invalid">
					Save Changes
				</button>
			</div>
		</form>
	</div>
</nz-spin>
